export default (name: string): string | undefined => {
  const win = window as any;
  if (win.env && win.env[name] !== undefined) {
    return win.env[name];
  }
  return process.env[name];
};
